var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-popover",
    {
      attrs: {
        visible: !_vm.readOnly && _vm.open,
        overlayClassName: "no-padding archive-filter",
        placement: "bottom",
        trigger: "click",
      },
      on: {
        visibleChange: function (isVisible) {
          return (_vm.open = isVisible)
        },
      },
    },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c("div", { staticClass: "filter-wrapper-form" }, [
          _c("div", { staticClass: "filter-wrapper-form-title" }, [
            _c(
              "span",
              {
                staticClass: "material-icons closeIcon",
                on: { click: _vm.close },
              },
              [_vm._v(" close ")]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "material-icons filterIcon" }, [
              _vm._v(" " + _vm._s(_vm.icon) + " "),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "filterName ml-2" }, [
              _vm._v(
                _vm._s(_vm.filterMetas[_vm.clone.name].title || _vm.clone.name)
              ),
            ]),
          ]),
          _vm._v(" "),
          [
            "email",
            "fullname",
            "country",
            "city",
            "os",
            "visitingPage",
            "browser",
          ].includes(_vm.clone.name)
            ? _c(
                "div",
                { staticClass: "w-100 mb-3 row" },
                _vm._l(_vm.ruleList, function (rule, index) {
                  return _c(
                    "div",
                    {
                      key: rule.id,
                      staticClass: "row mx-2 mb-2",
                      staticStyle: { width: "100%" },
                    },
                    [
                      _c("span", { staticClass: "col-md-1" }, [
                        _c("input", {
                          attrs: { type: "checkbox", id: rule.label },
                          domProps: { checked: _vm.clone.rule === rule.id },
                          on: {
                            click: function ($event) {
                              _vm.clone.rule = rule.id
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "col-md-10 d-flex flex-column" },
                        [
                          _c("label", { attrs: { for: rule.label } }, [
                            _vm._v(_vm._s(rule.label)),
                          ]),
                          _vm._v(" "),
                          _vm.clone.rule === rule.id
                            ? _c("a-input", {
                                staticClass: "row select-input",
                                model: {
                                  value: _vm.clone.value,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.clone, "value", $$v)
                                  },
                                  expression: "clone.value",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          ["firstSeen", "lastSeen", "connectionTime"].includes(_vm.clone.name)
            ? _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-story",
                      attrs: {
                        value: _vm.clone.value,
                        placeholder: _vm.$t("chatbotv2.wholeTimeSpan"),
                        "filter-option": false,
                      },
                      on: {
                        select: function ($event) {
                          return _vm.handleSelect($event, "option")
                        },
                      },
                    },
                    _vm._l(_vm.periods, function (period) {
                      return _c(
                        "a-select-option",
                        { key: period.value, attrs: { value: period.value } },
                        [
                          _c("span", { staticClass: "blockTypeText" }, [
                            _vm._v(
                              _vm._s(_vm.$t("chatbotv2.time." + period.value))
                            ),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          ["tags"].includes(_vm.clone.name)
            ? _c(
                "div",
                { staticClass: "w-100" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "select-story",
                      attrs: { value: _vm.tagName, "filter-option": false },
                      on: {
                        select: function ($event) {
                          return _vm.handleSelect($event, "tag")
                        },
                      },
                    },
                    _vm._l(_vm.tags, function (tag) {
                      return _c(
                        "a-select-option",
                        {
                          key: tag._id,
                          attrs: { value: tag._id + " " + tag.name },
                        },
                        [
                          _c("span", { staticClass: "blockTypeText" }, [
                            _vm._v(_vm._s(tag.name)),
                          ]),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "w-100",
              staticStyle: { "margin-top": "20px", width: "100%" },
            },
            [
              _c(
                "a-button",
                {
                  staticClass: "d-block w-100",
                  attrs: { type: "primary", disabled: !_vm.isChanged() },
                  on: { click: _vm.saveValue },
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("chatbotv2.applyFilter")) +
                      "\n                "
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-wrapper-preview" }, [
        _c("span", { staticClass: "material-icons mainIcon" }, [
          _vm._v(" " + _vm._s(_vm.icon) + " "),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "material-icons closeIcon",
            on: { click: _vm.remove },
          },
          [_vm._v(" close ")]
        ),
        _vm._v(" "),
        _c("span", { attrs: { "text-truncate": "", "text-actions": "" } }, [
          _c("span", { attrs: { "text-weight": "semi-bold" } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.getFilterLabel()))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }